import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  cartItem: PropTypes.shape({
    vendor: PropTypes.shape({
      id: PropTypes.string,
      organization_name: PropTypes.string,
    }),
  }),
};

const CartItemVendor = ({ cartItem }) => {
  const vendorName = cartItem?.vendor?.organization_name;

  if (!vendorName) {
    return null;
  }

  return (
    <p className="checkout-cart-item-description">
      Vendor: <span className="text-extra-bold">{vendorName}</span>
    </p>
  );
};

CartItemVendor.propTypes = propTypes;

export default CartItemVendor;
